import { render, staticRenderFns } from "./impersonate-popup.vue?vue&type=template&id=2957c95a&scoped=true&"
import script from "./impersonate-popup.ts?vue&type=script&lang=ts&"
export * from "./impersonate-popup.ts?vue&type=script&lang=ts&"
import style0 from "./impersonate-popup.scss?vue&type=style&index=0&id=2957c95a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2957c95a",
  null
  
)

export default component.exports